export default "__VITE_ASSET__C$6FFVnL__"